(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if(scrollTop == 0){
        document.body.classList.add("touchtop");        
      }else{
        document.body.classList.remove("touchtop");
      }
 
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    /*
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    */

    hide() {
    if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure?.();
      this.closeSearchModal?.();
    }   

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
    /*
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    */

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header?.querySelector('details-modal, details[aria-controls="SearchModal"], details.search-modal') ||
        document.querySelector('details-modal, details[aria-controls="SearchModal"], details.search-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        try {
          this.searchModal.close(false);
          return;
        } catch (e) {
        }
      }

      const detailsEl =
        (this.searchModal && this.searchModal.tagName === 'DETAILS' ? this.searchModal : null) ||
        this.header?.querySelector('details[open][aria-controls="SearchModal"], details.search-modal[open]') ||
        document.querySelector('details[open][aria-controls="SearchModal"], details.search-modal[open]');

      if (detailsEl) {
        detailsEl.open = false;
        detailsEl.removeAttribute('open');
      }
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-mainvisual"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
    const swiperEl = document.querySelector('#top-mainvisual-swiper');
    if (!swiperEl) return;
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) {
        document.querySelectorAll('.top-mainvisual-nav').forEach(function(b){ b.style.display = 'none'; });
        return;
    }
    const topMainvisualSwiper = new Swiper('#top-mainvisual-swiper',{
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        speed: 600,
        autoplay:{
        delay: 3200,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: '#top-mainvisual-next',
            prevEl: '#top-mainvisual-prev',
        },
        pagination: {
            el: '#top-mainvisual-pagination',
            clickable: true,
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
